// src/context/Adviser/Utils/formUtils.js
import { useAdviserContext } from "../AdviserContext";

// Get value (handles plain values and {value, path} objects)
export const gv = (x) =>
  x && typeof x === "object" && "value" in x ? x.value : x ?? "";

export const useFormUtils = () => {
  const { dispatch } = useAdviserContext();

  /**
   * Generic change handler:
   * - sectionPath:   e.g. "accountantDetails.personalReferees"
   * - fieldPath:     e.g. "refereeEmailAddress" (can also be "a.b.c" if you want)
   * - index:         number if sectionPath points to an array item (e.g. personalReferees[index])
   */
  const hc =
    (sectionPath, fieldPath, index = null) =>
    (eOrValue) => {
      const value = eOrValue?.target ? eOrValue.target.value : eOrValue;
      // console.log("[hc] PATCH_SECTION:", {
      //   sectionPath,
      //   fieldPath,
      //   index,
      //   value,
      // });
      dispatch({
        type: "PATCH_SECTION",
        payload: { sectionPath, fieldPath, index, value },
      });
    };

  const hcr =
    (sectionPath, fieldPath, fixedValue, index = null) =>
    () => {
      // console.log("[hcr] PATCH_SECTION:", {
      //   sectionPath,
      //   fieldPath,
      //   index,
      //   value: fixedValue,
      // });
      dispatch({
        type: "PATCH_SECTION",
        payload: { sectionPath, fieldPath, index, value: fixedValue },
      });
    };

  return { gv, hc, hcr };
};
